export const isLessonRecommendation = type => {
  return type === 'LESSON';
};
export const userCompletedContentAfterQuiz = (quizCompletionDate, progress) => {
  return Object.values(progress).some(contentProgress => contentProgress.completed && contentProgress.updatedAt > quizCompletionDate);
};